export const DEFAULT_FEATURE_FLAG_TRAFFIC_KEY = '-'

export function resolveFeatureFlagTrafficKey(currentUser) {
  if (currentUser && currentUser.customerIdHash) {
    return currentUser.customerIdHash
  }

  return DEFAULT_FEATURE_FLAG_TRAFFIC_KEY
}
